import React from "react";
import { Row, Col } from "react-bootstrap";
import { LoginForm, LoginImage, MsalLogin } from "./components";

const Login = () => {
  return (
    <>
      <div className="wrapper">
        <div>
          <Row className="vh-100 g-0 overflow-auto">
            <Col lg={6}>
              <LoginForm /> 
            </Col>
            <Col lg={6}>
              <LoginImage />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Login;
